<template>
    <div>
        <h1 class="mb-8 font-bold text-3xl">
            <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('manage.warehouses')">Warehouses</inertia-link>
            <span class="text-indigo-400 font-medium">/</span> Update
        </h1>
        <div class="bg-white rounded shadow overflow-hidden max-w-3xl">
            <form @submit.prevent="submit">
                <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
                    <text-input v-model="form.code" :errors="$page.props.errors.code" class="pr-6 pb-8 w-full lg:w-1/2" label="Code" />
                    <text-input v-model="form.name" :errors="$page.props.errors.name" class="pr-6 pb-8 w-full lg:w-1/2" label="Warehouse Name" />
                    <select-input v-model="form.location" :errors="$page.props.errors.location" class="pr-6 pb-8 w-full lg:w-1/2" label="Warehouse Location">
                        <option :value="null" />
                        <option v-for="(location, lkey) in $page.props.locations" :value="lkey" :key="lkey">{{ location }}</option>
                    </select-input>
                    <text-input v-model="form.address" :errors="$page.props.errors.address" class="pr-6 pb-8 w-full lg:w-1/2" label="Address" />

                </div>

                <div class="p-8">
                  <h3 class="mb-2">Location Managers</h3>
                  <div class="bg-gray-100 p-2">
                    <div class="flex mr-2">
                      <select  class="form-select rounded-r-none w-full lg:w-1/2" v-model="selectedNewManager">
                        <option :value="null" />
                        <option v-for="user in selectableUsers" :value="user" :key="user.id">{{ user.first_name }} {{ user.last_name }}</option>
                      </select>
                      <button class="rounded-l-none btn btn-gray px-3 text-xs" @click.prevent="addSelectedManager">Add Manager</button>
                    </div>

                    <p class="text-sm py-2 text-gray-400">Added Managers</p>
                    <div class="bg-white border border-gray-300 px-3 py-3 rounded flex justify-between" v-for="manager in warehouse_managers" :key="manager.id">
                      <div>{{ manager.first_name }} {{ manager.last_name }}</div>
                      <div><button class="btn-red p-1 text-xs" @click.prevent="removeManager(manager)">remove</button></div>
                    </div>
                  </div>

                </div>

                <div class="px-4 my-4">
                    <div class="flex items-center justify-between border-b py-3">
                        <div class="text-sm font-medium">Open on Saturday</div>
                        <toggle v-model="form.open_sat" />
                    </div>
                    <div class="flex items-center justify-between border-b py-3">
                        <div class="text-sm font-medium">Open on Sunday</div>
                        <toggle v-model="form.open_sun" />
                    </div>
                    <div class="flex items-center justify-between border-b py-3">
                        <div class="text-sm font-medium">Open on Monday</div>
                        <toggle v-model="form.open_mon" />
                    </div>
                    <div class="flex items-center justify-between border-b py-3">
                        <div class="text-sm font-medium">Open on Tuesday</div>
                        <toggle v-model="form.open_tue" />
                    </div>
                    <div class="flex items-center justify-between border-b py-3">
                        <div class="text-sm font-medium">Open on Wednesday</div>
                        <toggle v-model="form.open_wed" />
                    </div>
                    <div class="flex items-center justify-between border-b py-3">
                        <div class="text-sm font-medium">Open on Thursday</div>
                        <toggle v-model="form.open_thu" />
                    </div>
                    <div class="flex items-center justify-between py-3">
                        <div class="text-sm font-medium">Open on Friday</div>
                        <toggle v-model="form.open_fri" />
                    </div>
                </div>

                <div class="px-8 py-4 bg-gray-100 border-t border-gray-200 flex justify-end items-center">
                    <loading-button :loading="sending" class="btn-primary" type="submit">Update Warehouse</loading-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
  var lfind = require('lodash/find')
  import Layout from '@/Shared/Admin/Layout'
  import LoadingButton from '@/Shared/LoadingButton'
  import SelectInput from '@/Shared/SelectInput'
  import TextInput from '@/Shared/TextInput'
  import Toggle from '@/Shared/Toggle'

  export default {
    metaInfo: { title: 'Create Warehouse' },
    layout: Layout,
    components: {
      LoadingButton,
      SelectInput,
      TextInput,
      Toggle
    },
    props: {
      warehouse: {
        type: Object,
        required: true
      },
      managers: {
        type: Array
      }
    },
    remember: 'form',
    data() {
      return {
        sending: false,
        warehouse_managers: this.managers,
        selectedNewManager: null,
        form: {
          code: this.warehouse.code,
          name: this.warehouse.name,
          location: this.warehouse.location,
          manager_id: this.warehouse.manager_id,
          google_maps: this.warehouse.google_maps,
          address: this.warehouse.address,
          open_sat: this.warehouse.open_sat == 1,
          open_sun: this.warehouse.open_sun == 1,
          open_mon: this.warehouse.open_mon == 1,
          open_tue: this.warehouse.open_tue == 1,
          open_wed: this.warehouse.open_wed == 1,
          open_thu: this.warehouse.open_thu == 1,
          open_fri: this.warehouse.open_fri == 1
        },
      }
    },
    computed: {
      selectableUsers: function() {
        return this.$page.props.users.filter((x) => {
          if(!lfind(this.warehouse_managers, {id: x.id})) {
            return true;
          }
          return false;
        })
      }
    },


    methods: {
      submit() {
        this.sending = true

        this.form.managers = this.warehouse_managers;

        this.$inertia.put(this.route('manage.warehouses.update', this.warehouse.id), this.form, {
          onFinish: () => this.sending = false
        })
      },
      addSelectedManager() {
        if(!lfind(this.warehouse_managers, {id: this.selectedNewManager.id}) && this.selectedNewManager !== null) {
          this.warehouse_managers.push(Object.assign({}, this.selectedNewManager));
        }
        this.selectedNewManager = null;
      },

      removeManager(manager) {
        let Indx = this.warehouse_managers.indexOf(manager);
        this.warehouse_managers.splice(Indx, 1);
      }
    },
  }
</script>

